import template from "./packlab-img-uploader.html.twig";

Packlab.Component.extend('packlab-img-uploader', 'packlab-uploader', {
    template
});